<template>
  <div>
    <!-- ===================== SIDEBAR ===================== -->
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
      :permanent="$vuetify.breakpoint.mdAndUp"
      :temporary="$vuetify.breakpoint.smAndDown"
      width="248"
      class="ai-drawer"
      v-if="usuarioLogado && user.tipo != 'ENFERMAGEM'"
    >
      <!-- Marca / logo da empresa -->
      <div class="ai-drawer__brand">
        <v-img
          v-if="companyobj.logoUrl"
          :src="companyobj.logoUrl"
          max-height="56"
          contain
          class="ai-drawer__logo"
        ></v-img>
        <div v-else class="ai-drawer__brand-text">
          <v-icon color="white" class="mr-2">mdi-hospital-box</v-icon>
          <span>AiNurse</span>
        </div>
      </div>

      <v-divider dark class="ai-drawer__divider"></v-divider>

      <!-- Menu -->
      <v-list nav dense class="ai-drawer__list">
        <v-list-item
          v-for="item in menuVisivel"
          :key="item.to"
          :to="item.to"
          link
          active-class="ai-drawer__item--active"
          class="ai-drawer__item"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.label }}</v-list-item-title>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <v-divider dark class="ai-drawer__divider"></v-divider>
        <div class="ai-drawer__footer">
          <v-icon small color="rgba(255,255,255,0.6)" class="mr-2">mdi-shield-check</v-icon>
          <span>AiNurse · Intelite</span>
        </div>
      </template>
    </v-navigation-drawer>

    <!-- ===================== TOPBAR ===================== -->
    <v-app-bar
      app
      clipped-left
      flat
      v-if="usuarioLogado"
      color="white"
      height="64"
      class="ai-appbar"
    >
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        v-if="user.tipo != 'ENFERMAGEM' && $vuetify.breakpoint.smAndDown"
        color="secondary"
      ></v-app-bar-nav-icon>

      <div class="ai-appbar__title">
        <span class="ai-appbar__page">{{ tituloPagina }}</span>
        <span class="ai-appbar__sub" v-if="companyobj.nome">{{ companyobj.nome }}</span>
      </div>

      <v-spacer></v-spacer>

      <!-- Menu do usuário -->
      <v-menu bottom offset-y min-width="220" transition="slide-y-transition">
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on" class="ai-user-btn text-none" height="46">
            <v-avatar size="38" color="primary" class="ai-user-avatar">
              <v-img v-if="user.imagem" :src="user.imagem"></v-img>
              <span v-else class="white--text font-weight-bold">{{ iniciais }}</span>
            </v-avatar>
            <div class="ai-user-meta d-none d-sm-flex">
              <span class="ai-user-name">{{ user.nome }}</span>
              <span class="ai-user-role">{{ papelLegivel }}</span>
            </div>
            <v-icon small color="grey" class="d-none d-sm-flex">mdi-chevron-down</v-icon>
          </v-btn>
        </template>

        <v-list dense>
          <v-list-item>
            <v-list-item-avatar color="primary">
              <v-img v-if="user.imagem" :src="user.imagem"></v-img>
              <span v-else class="white--text font-weight-bold">{{ iniciais }}</span>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold secondary--text">{{ user.nome }}</v-list-item-title>
              <v-list-item-subtitle>{{ companyobj.nome }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item @click.stop="teste()">
            <v-list-item-icon class="mr-3"><v-icon small>mdi-account-edit</v-icon></v-list-item-icon>
            <v-list-item-title>Editar usuário</v-list-item-title>
          </v-list-item>
          <v-list-item @click.stop="teste()">
            <v-list-item-icon class="mr-3"><v-icon small>mdi-lock-reset</v-icon></v-list-item-icon>
            <v-list-item-title>Alterar senha</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item @click="Sair()">
            <v-list-item-icon class="mr-3"><v-icon small color="error">mdi-logout</v-icon></v-list-item-icon>
            <v-list-item-title class="error--text">Sair</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    props: {
      source: String,
    },
    data() {
      return {
        drawer: null,
        menu: [
          { to: '/home', label: 'Dashboard', icon: 'mdi-view-dashboard', roles: ['ADMIN', 'GERENTE'] },
          { to: '/empresas', label: 'Empresas', icon: 'mdi-domain', roles: ['ADMIN'] },
          { to: '/usuarios', label: 'Usuários', icon: 'mdi-account-group', roles: ['ADMIN', 'GERENTE'] },
          { to: '/chamadores', label: 'Chamadores', icon: 'mdi-room-service', roles: ['ADMIN'] },
          { to: '/paineis', label: 'Painéis', icon: 'mdi-television-classic', roles: ['ADMIN'] },
          { to: '/chamados', label: 'Chamados', icon: 'mdi-bell-ring', roles: ['ADMIN', 'GERENTE'] },
        ],
      }
    },

    mounted: function () {
      if (sessionStorage.getItem('accToken') != null)
        this.$store.dispatch('Logar', this.token)
      if (sessionStorage.getItem('user') != null)
        this.$store.dispatch('SetUser')
      if (sessionStorage.getItem('company') != null)
        this.$store.dispatch('SetCompany')
    },

    computed: {
      ...mapState({
        usuarioLogado: state => state.isMenuVisible,
        user: state => state.userObj,
        companyobj: state => state.companyObj
      }),

      menuVisivel() {
        const tipo = this.user && this.user.tipo
        return this.menu.filter(i => !i.roles || i.roles.indexOf(tipo) !== -1)
      },

      iniciais() {
        const nome = (this.user && this.user.nome) || ''
        const partes = nome.trim().split(/\s+/).filter(Boolean)
        if (!partes.length) return '?'
        if (partes.length === 1) return partes[0].substring(0, 2).toUpperCase()
        return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase()
      },

      papelLegivel() {
        const map = { ADMIN: 'Administrador', GERENTE: 'Gerente', ENFERMAGEM: 'Enfermagem' }
        return map[this.user && this.user.tipo] || ''
      },

      tituloPagina() {
        const map = {
          home: 'Dashboard',
          empresas: 'Empresas',
          usuarios: 'Usuários',
          chamadores: 'Chamadores',
          paineis: 'Painéis',
          chamados: 'Chamados',
          painel: 'Painel',
        }
        return map[this.$route.name] || 'AiNurse'
      },
    },

    methods: {
      teste() {},

      Sair() {
        this.$store.dispatch('Sair')
        this.$router.push({ path: '/login' })
      },
    }
  }
</script>

<style scoped>
/* ===== Sidebar ===== */
.ai-drawer >>> .v-navigation-drawer__content {
  background: linear-gradient(180deg, #0f0f41 0%, #15164d 60%, #1a1b57 100%);
}
.ai-drawer__brand {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
}
.ai-drawer__logo {
  background: #fff;
  border-radius: 8px;
  padding: 4px 8px;
  width: 100%;
}
.ai-drawer__brand-text {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 20px;
  font-weight: 800;
  letter-spacing: 0.5px;
}
.ai-drawer__divider {
  border-color: rgba(255, 255, 255, 0.12) !important;
}
.ai-drawer__list {
  padding: 12px 10px;
}
.ai-drawer__item {
  border-radius: 10px !important;
  margin-bottom: 4px;
  min-height: 46px;
}
.ai-drawer__item .v-list-item__title {
  color: rgba(255, 255, 255, 0.82);
  font-weight: 600;
  font-size: 0.95rem;
}
.ai-drawer__item .v-icon {
  color: rgba(255, 255, 255, 0.7) !important;
}
.ai-drawer__item:hover {
  background: rgba(255, 255, 255, 0.06);
}
.ai-drawer__item--active {
  background: linear-gradient(90deg, #038b8b 0%, #03a3a3 100%) !important;
}
.ai-drawer__item--active::before {
  opacity: 0 !important;
}
.ai-drawer__item--active .v-list-item__title,
.ai-drawer__item--active .v-icon {
  color: #fff !important;
}
.ai-drawer__footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px;
  color: rgba(255, 255, 255, 0.55);
  font-size: 0.78rem;
}

/* ===== Topbar ===== */
.ai-appbar {
  border-bottom: 1px solid #e8ebf2 !important;
}
.ai-appbar__title {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
  margin-left: 4px;
}
.ai-appbar__page {
  font-size: 1.15rem;
  font-weight: 700;
  color: #0f0f41;
}
.ai-appbar__sub {
  font-size: 0.74rem;
  color: #8a93a6;
  font-weight: 500;
}
.ai-user-btn {
  border-radius: 10px !important;
  padding: 0 8px !important;
}
.ai-user-meta {
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.15;
  margin: 0 8px;
}
.ai-user-name {
  font-size: 0.88rem;
  font-weight: 700;
  color: #1f2433;
}
.ai-user-role {
  font-size: 0.72rem;
  color: #8a93a6;
}
</style>
